<template>
  <div class="page page__list">
    <div class="nav">
      <span :class="selected1 == '月分析' ? 'selected1' : ''" @click="toggle1('月分析')">月分析</span>
      <span>|</span>
      <span :class="selected1 == '日分析' ? 'selected1' : ''" @click="toggle1('日分析')">日分析</span>
      <span>|</span>
      <span :class="selected1 == '明细' ? 'selected1' : ''" @click="toggle1('明细')">明细</span>
    </div>

    <month v-if="selected1 == '月分析'"></month>
  
    <day v-if="selected1 == '日分析'"></day>

    <detail class="lll" v-if="selected1 == '明细'"></detail>

  </div>
</template>

<script>
import Month from "@/components/PurchaseOrderReport/Month.vue";
import Day from "@/components/PurchaseOrderReport/Day.vue";
import Detail from "@/components/PurchaseOrderReport/Detail.vue";

export default {
  components: {
    Month,
    Day,
    Detail
  },
  data() {
    return {
      selected1: '月分析',
    }
  },
  methods: {
    toggle1(val) {
      this.selected1 = val
    }
  }
}
</script>

<style scoped>
.nav {
  padding: 10px 20px;
  display: flex;
  justify-content: space-around;
  background: var(--weui-BG);
}
.nav .selected1 {
  color: #38559F;
}

.lll {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
}
@media screen and (min-width: 500px) {
  .nav{
    display: none;
  }
}
</style>